// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InviteToWorkspaceContent_Ug6Hn {
  width: 95%;
  height: 100%;
  margin: 0 auto;
  border-radius: 8px;
  border: 1px solid var(--ececf1-border);
  background: #fff;
  padding: 8px 20px 20px 20px;
  box-sizing: border-box;
  max-height: 70vh;
  overflow-y: scroll;

  .workspaceSectionLabel_mGr_j {
    padding: 20px 0;
    border-bottom: 1px solid #ebebeb;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    p {
      margin: 0;
      font-size: 15px;
    }
    .descSection_PQrza {
      font-size: 15px;
      color: #717171;
    }
    .accessInfo_aQN4v {
      display: flex;
      text-align: end;
      align-items: center;
      gap: 10px;
      p {
        margin: 0;
      }
      .access_jovoH {
        display: flex;
        align-items: center;
        gap: 5px;
      }
      .accessType_ViVvF {
        color: var(--_10a37f-background);
        font-size: 13px;
      }
      .rol_JC5qN {
        font-size: 13px;
        color: #717171;
      }
      img {
        width: 30px;
        height: 30px;
        border-radius: 999px;
      }
    }

    .spendingControls_msryQ {
      width: fit-content;
      display: flex;
      gap: 10px;
      .inputContainer_ZnQCT {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      input {
        width: fit-content;
        width: 100px;
        border: none;
        outline: none;
        font-size: 14px;
        font-weight: 400;
        color: var(--_75-color);
        min-height: 21px !important;
        background-color: var(--f4-background);
        border-radius: 5px;
        font-family: "Inter", sans-serif;
        box-sizing: border-box;
        width: 100%;
        field-sizing: content;
        min-height: 21px !important;
        padding: 8px 4px;
      }
    }
  }
  .mergPlanContainer_mL1tS {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 20px;
    > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .inputContainer_ZnQCT {
      display: flex;
      align-items: center;
      width: fit-content;
      border: none;
      outline: none;
      font-size: 14px;
      font-weight: 400;
      color: var(--_75-color);
      min-height: 21px !important;
      background-color: var(--f4-background);
      border-radius: 5px;
      font-family: "Inter", sans-serif;
      box-sizing: border-box;
      field-sizing: content;
      padding: 8px;
      gap: 5px;
      input {
        background-color: transparent;
        border: none;
        outline: none;
      }
      input::placeholder {
        color: var(--_71717a-color);
      }
    }
  }

  .mergePlanSwitchContainer_KXC_c {
    display: flex;
    align-items: center;
    gap: 5px;
    svg {
      height: 20px;
      width: 20px;
      fill: #c5c5c5;
      color: #c5c5c5;
    }
    .activeMerge_R5Uxc {
      fill: var(--_16c098-background);
      color: var(--_16c098-background);
    }
  }

  .switch_BlbKT {
    position: relative;
    display: inline-block;
    width: 40px;
    margin-top: 7px;
    height: 24px;
  }

  .switch_BlbKT input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider_y2ope {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--c-background);
    transition: 0.4s;
    border-radius: 24px;
  }

  .slider_y2ope:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 2px;
    bottom: 2px;
    background-color: var(--white-background);
    transition: 0.4s;
    border-radius: 50%;
  }

  input:checked + .slider_y2ope {
    background-color: var(--_16c098-background);
  }
  input:checked + .bgBlack_KvRgX {
    background-color: #000000;
  }

  input:checked + .slider_y2ope:before {
    transform: translateX(16px);
  }
}

.editableInputContainer_auJhB{
  span{
    font-weight: 400;
    font-size: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/NewWorkspace/InviteToWorkspace/InviteToWorkspace.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;;EAElB;IACE,eAAe;IACf,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;;IAET;MACE,SAAS;MACT,eAAe;IACjB;IACA;MACE,eAAe;MACf,cAAc;IAChB;IACA;MACE,aAAa;MACb,eAAe;MACf,mBAAmB;MACnB,SAAS;MACT;QACE,SAAS;MACX;MACA;QACE,aAAa;QACb,mBAAmB;QACnB,QAAQ;MACV;MACA;QACE,gCAAgC;QAChC,eAAe;MACjB;MACA;QACE,eAAe;QACf,cAAc;MAChB;MACA;QACE,WAAW;QACX,YAAY;QACZ,oBAAoB;MACtB;IACF;;IAEA;MACE,kBAAkB;MAClB,aAAa;MACb,SAAS;MACT;QACE,aAAa;QACb,sBAAsB;QACtB,mBAAmB;MACrB;MACA;QACE,kBAAkB;QAClB,YAAY;QACZ,YAAY;QACZ,aAAa;QACb,eAAe;QACf,gBAAgB;QAChB,uBAAuB;QACvB,2BAA2B;QAC3B,sCAAsC;QACtC,kBAAkB;QAClB,gCAAgC;QAChC,sBAAsB;QACtB,WAAW;QACX,qBAAqB;QACrB,2BAA2B;QAC3B,gBAAgB;MAClB;IACF;EACF;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,SAAS;IACT;MACE,aAAa;MACb,8BAA8B;MAC9B,mBAAmB;IACrB;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,kBAAkB;MAClB,YAAY;MACZ,aAAa;MACb,eAAe;MACf,gBAAgB;MAChB,uBAAuB;MACvB,2BAA2B;MAC3B,sCAAsC;MACtC,kBAAkB;MAClB,gCAAgC;MAChC,sBAAsB;MACtB,qBAAqB;MACrB,YAAY;MACZ,QAAQ;MACR;QACE,6BAA6B;QAC7B,YAAY;QACZ,aAAa;MACf;MACA;QACE,2BAA2B;MAC7B;IACF;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR;MACE,YAAY;MACZ,WAAW;MACX,aAAa;MACb,cAAc;IAChB;IACA;MACE,+BAA+B;MAC/B,gCAAgC;IAClC;EACF;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,YAAY;EACd;;EAEA;IACE,UAAU;IACV,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,qCAAqC;IACrC,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,yCAAyC;IACzC,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,2CAA2C;EAC7C;EACA;IACE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":[".InviteToWorkspaceContent {\n  width: 95%;\n  height: 100%;\n  margin: 0 auto;\n  border-radius: 8px;\n  border: 1px solid var(--ececf1-border);\n  background: #fff;\n  padding: 8px 20px 20px 20px;\n  box-sizing: border-box;\n  max-height: 70vh;\n  overflow-y: scroll;\n\n  .workspaceSectionLabel {\n    padding: 20px 0;\n    border-bottom: 1px solid #ebebeb;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n\n    p {\n      margin: 0;\n      font-size: 15px;\n    }\n    .descSection {\n      font-size: 15px;\n      color: #717171;\n    }\n    .accessInfo {\n      display: flex;\n      text-align: end;\n      align-items: center;\n      gap: 10px;\n      p {\n        margin: 0;\n      }\n      .access {\n        display: flex;\n        align-items: center;\n        gap: 5px;\n      }\n      .accessType {\n        color: var(--_10a37f-background);\n        font-size: 13px;\n      }\n      .rol {\n        font-size: 13px;\n        color: #717171;\n      }\n      img {\n        width: 30px;\n        height: 30px;\n        border-radius: 999px;\n      }\n    }\n\n    .spendingControls {\n      width: fit-content;\n      display: flex;\n      gap: 10px;\n      .inputContainer {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n      }\n      input {\n        width: fit-content;\n        width: 100px;\n        border: none;\n        outline: none;\n        font-size: 14px;\n        font-weight: 400;\n        color: var(--_75-color);\n        min-height: 21px !important;\n        background-color: var(--f4-background);\n        border-radius: 5px;\n        font-family: \"Inter\", sans-serif;\n        box-sizing: border-box;\n        width: 100%;\n        field-sizing: content;\n        min-height: 21px !important;\n        padding: 8px 4px;\n      }\n    }\n  }\n  .mergPlanContainer {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 20px;\n    > div {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n    }\n\n    .inputContainer {\n      display: flex;\n      align-items: center;\n      width: fit-content;\n      border: none;\n      outline: none;\n      font-size: 14px;\n      font-weight: 400;\n      color: var(--_75-color);\n      min-height: 21px !important;\n      background-color: var(--f4-background);\n      border-radius: 5px;\n      font-family: \"Inter\", sans-serif;\n      box-sizing: border-box;\n      field-sizing: content;\n      padding: 8px;\n      gap: 5px;\n      input {\n        background-color: transparent;\n        border: none;\n        outline: none;\n      }\n      input::placeholder {\n        color: var(--_71717a-color);\n      }\n    }\n  }\n\n  .mergePlanSwitchContainer {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    svg {\n      height: 20px;\n      width: 20px;\n      fill: #c5c5c5;\n      color: #c5c5c5;\n    }\n    .activeMerge {\n      fill: var(--_16c098-background);\n      color: var(--_16c098-background);\n    }\n  }\n\n  .switch {\n    position: relative;\n    display: inline-block;\n    width: 40px;\n    margin-top: 7px;\n    height: 24px;\n  }\n\n  .switch input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n  }\n\n  .slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: var(--c-background);\n    transition: 0.4s;\n    border-radius: 24px;\n  }\n\n  .slider:before {\n    position: absolute;\n    content: \"\";\n    height: 20px;\n    width: 20px;\n    left: 2px;\n    bottom: 2px;\n    background-color: var(--white-background);\n    transition: 0.4s;\n    border-radius: 50%;\n  }\n\n  input:checked + .slider {\n    background-color: var(--_16c098-background);\n  }\n  input:checked + .bgBlack {\n    background-color: #000000;\n  }\n\n  input:checked + .slider:before {\n    transform: translateX(16px);\n  }\n}\n\n.editableInputContainer{\n  span{\n    font-weight: 400;\n    font-size: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"InviteToWorkspaceContent": `InviteToWorkspaceContent_Ug6Hn`,
	"workspaceSectionLabel": `workspaceSectionLabel_mGr_j`,
	"descSection": `descSection_PQrza`,
	"accessInfo": `accessInfo_aQN4v`,
	"access": `access_jovoH`,
	"accessType": `accessType_ViVvF`,
	"rol": `rol_JC5qN`,
	"spendingControls": `spendingControls_msryQ`,
	"inputContainer": `inputContainer_ZnQCT`,
	"mergPlanContainer": `mergPlanContainer_mL1tS`,
	"mergePlanSwitchContainer": `mergePlanSwitchContainer_KXC_c`,
	"activeMerge": `activeMerge_R5Uxc`,
	"switch": `switch_BlbKT`,
	"slider": `slider_y2ope`,
	"bgBlack": `bgBlack_KvRgX`,
	"editableInputContainer": `editableInputContainer_auJhB`
};
export default ___CSS_LOADER_EXPORT___;
